import {UserLayoutRequest} from 'src/openapi/admin/models/UserLayoutRequest';

export const SCOPE_KEY = 'content-layout';

export const COLUMN_WIDTHS = {
    NAME: 500,
    ENTITY_TYPE: 400,
    LAYOUT_TYPE: 500,
    DEFAULT: 100,
} as const;

export const SEARCH_INPUT_WIDTH = 345;

export function makeLayoutQueryKey(userId: number, request: UserLayoutRequest): string {
    return `${userId}::${JSON.stringify(request)}`;
}
